export const STRATEGY_DESCRIPTION_PLACEHOLDER = {
  STOCK_NAME: "{{stock_name}}",
  SHORT_NAME: "{{short_name}}",
  TICKER: "{{ticker}}",
  MARKET: "{{market}}"
};

const PLACEHOLDER_TO_FIELD = {
  [STRATEGY_DESCRIPTION_PLACEHOLDER.STOCK_NAME]: "stock_name",
  [STRATEGY_DESCRIPTION_PLACEHOLDER.SHORT_NAME]: "short_name",
  [STRATEGY_DESCRIPTION_PLACEHOLDER.TICKER]: "ticker",
  [STRATEGY_DESCRIPTION_PLACEHOLDER.MARKET]: "market"
};

/**
 * Replaces stock-related placeholders in a transaction strategy description.
 * Missing values become empty strings; null/empty description is returned as-is.
 *
 * @param {string|null|undefined} description
 * @param {{ stock_name?: string, short_name?: string, ticker?: string, market?: string }} values
 * @returns {string|null|undefined}
 */
export default function resolveStrategyDescriptionPlaceholders(
  description,
  values = {}
) {
  if (description == null || description === "") {
    return description;
  }

  let resolved = description;

  Object.entries(PLACEHOLDER_TO_FIELD).forEach(([placeholder, field]) => {
    const value = values[field] ?? "";
    resolved = resolved.split(placeholder).join(String(value));
  });

  return resolved;
}
